import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SERVICING_COMPANIES_ACTION_TYPE } from '../actions';

const initialState = {};

const servicingCompaniesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SERVICING_COMPANIES_ACTION_TYPE.GET_SERVICING_COMPANIES:
        return payload || initialState;

      case SERVICING_COMPANIES_ACTION_TYPE.CREATE_SERVICING_COMPANY:
      case SERVICING_COMPANIES_ACTION_TYPE.EDIT_SERVICING_COMPANY:
        draft[payload.id] = payload;
        break;

      case SERVICING_COMPANIES_ACTION_TYPE.DELETE_SERVICING_COMPANY:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default servicingCompaniesReducer;
